import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import SrFilterOptionList from 'client/components/SrFilterOptionList';
import SrFilterDate from 'client/components/SrFilterDate';
import SrMapDrawn from 'client/components/SrMapDrawn';
import SrFormikField from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

class SrSearchFilterForm extends Component {
  static propTypes = {
    searchFilters: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    allowEmptyArray: PropTypes.bool,
    id: PropTypes.string.isRequired,
    optionList: PropTypes.array,
    multi: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    resultsCount: PropTypes.number,
    resultsCountIsLoading: PropTypes.bool.isRequired,
    market: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.searchFilters[props.id],
    };
  }

  _onChange = (eventOrValue) => {
    const { type } = this.props;

    let value = null;

    switch (type) {
      case 'option-list':
      case 'date':
      case 'location':
      case 'number':
        value = eventOrValue;
        break;
    }

    this.setState({ value });
    this.props.onChange(value);
  };

  _isValid = () => {
    const { type, allowEmptyArray } = this.props;
    const { value } = this.state;

    switch (type) {
      case 'option-list':
        return Array.isArray(value) && (allowEmptyArray || value.length);
      case 'date':
        return value && true;
      case 'location':
        return Array.isArray(value) && value.length;
      default:
        return false;
    }
  };

  _onSubmit = () => {
    this.props.onSubmit(this.state.value);
  }

  render() {
    const {
      id,
      optionList,
      multi,
      type,
      label,
      resultsCount,
      resultsCountIsLoading,
      market,
    } = this.props;
    const { value } = this.state;

    let componentDom = null;

    switch (type) {
      case 'option-list':
        componentDom = (
          <SrFilterOptionList
            optionList={optionList}
            multi={multi}
            onChange={this._onChange}
            value={value || []}
          />
        );
        break;
      case 'date':
        componentDom = <SrFilterDate onChange={this._onChange} value={value} />;
        break;
      case 'location':
        componentDom = (
          <div className='area'>
            <SrMapDrawn
              onChange={this._onChange}
              value={value}
              market={market}
            />
          </div>
        );
        break;
      case 'currency':
        componentDom = (
          <SrFormikField
            formField={{
              id: id,
              title: '',
              properties: {
                placeholder: '$1,200',
                onChange: this._onChange,
              },
              type: 'currency',
            }}
            value={value || null}
          />
        );
        break;
      default:
        throw new Error(`Not found component for filter type '${type}'`);
    }

    return (
      <div className='contentContainer'>
        <span className='headline'>{label}</span>
        <div>{componentDom}</div>
        <div className='saveFilterContainer'>
          <ButtonDeprecated
            theme={BUTTON_THEME_BLUE}
            onClick={this._onSubmit}
            disabled={resultsCountIsLoading}
          >
            {resultsCountIsLoading
              ? 'please wait...'
              : (typeof resultsCount === 'number'
                ? `done (${resultsCount} ${pluralize('match', resultsCount)})`
                : 'done'
              )
            }
          </ButtonDeprecated>
        </div>
      </div>
    );
  }
}

SrSearchFilterForm.displayName = 'SrSearchFilterForm';

export default SrSearchFilterForm;
